export default __webpack_public_path__ + "static/media/GiftSetProductInfo2.c870fd85.jpg";